var _defs, _path, _g, _g2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg4RoundMarque(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.88 42.44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "4-round-marque_svg__a",
    x: 0,
    y: 0,
    width: 34.88,
    height: 42.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h34.88v42.38H0V0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "4-round-marque_svg__b",
    x: 0,
    y: 0,
    width: 34.88,
    height: 42.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h34.88v42.38H0V0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fffffe",
    fillRule: "evenodd",
    d: "M23.81 19.59l2.97.03.29-1.06-2.97-.03-.29 1.06M21.7 32.7l.29-1.06-1.52-.01-.3 1.05 1.53.02"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4-round-marque_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fffffe",
    fillRule: "evenodd",
    d: "M22.44 24.51l1.53.01.29-1.06-1.52-.01-.3 1.06"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4-round-marque_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.43 17.05L23.59 17l.23-.84 3-1.05h-2.73l.23-.84h4.85l-.24.84-3 1h2.72zm-.78 2.8l-.85.6h-3.48l-.51-.62.42-1.51.85-.6h3.48l.51.61zM27.06 22l-4.84-.06.23-.83 4.85.05zm-.94 3.41l-4.85-.05.59-2.13.85-.6h2l.52.62-.35 1.28h1.44zm-.43 1.53h-3.82l3.61.79-.26.95-4 .7h3.82l-.22.8L20 30.1l.38-1.38 3.4-.59-3.05-.67.39-1.38 4.84.06zm-1.32 4.75h-1.44l-.29 1.05h1.44l-.23.84h-4.17l-.51-.62.42-1.5.85-.61h4.16zm-.94 3.41h-2l-.29 1.06h1.95l-.19.84h-4.84l.23-.84h2l.29-1.06h-2l.24-.84 4.84.05zm-1.3 4.66l-.85.61H17.8l-.51-.62.42-1.51.85-.6h1l-.24.84h-.73l-.29 1.06h3l.29-1.06h-.73l.23-.83h1l.51.62zm3-28.3l.85-.61h.74l-.23.84H26l-.29 1.05h1l.36-1.28.85-.61h1.53l.5.62-.39 1.53-.86.61H28l.24-.84h.48l.29-1H28L27.6 13l-.85.61h-1.53l-.51-.63zm.59-2.14h2L28 8.26l-2-.02.23-.83h4.84l-.23.84h-2l-.29 1.06h2l-.24.85h-4.84zm1-3.47h4.84l-.23.83h-4.84zM27.48 3l.85-.6h2l.52.62-.36 1.29H32l-.23.84h-4.85zm7.4-3h-8.16l-6 21.52h-9.53L22.18 0H14L1.45 24.61 0 29.75h18.49l-3.55 12.69h8.16l3.55-12.69h2.57l2.3-8.23H29L34.88 0z",
    fill: "#fffffe",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffffe",
    fillRule: "evenodd",
    d: "M28.07 4.25l1.52.01.3-1.05-1.53-.02-.29 1.06"
  })));
}

export default Svg4RoundMarque;